import React from "react";
import { withRouter, Redirect } from "react-router-dom";
import moment from "moment";
import * as _ from "lodash";
import userService from "../services/userService";
import MainContent from "./boxes/MainContent";
import PageHeader from "./boxes/PageHeader";
import PageBody from "./boxes/PageBody";
import LoadingScreen from "./LoadingScreen";
import ButtonBar from "./boxes/ButtonBar";
import StatsDataCard from "./boxes/StatsDataCard";
import DashboardProfileCard from "./boxes/DashboardProfileCard";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import tourDashboard from "./tours/tourDashboard";
import { withTranslation } from "react-i18next";
import { isFeatureEnabled } from "@reliance/feature-flags";
import { features } from "../services/constants";
import CareBalance from "./care-balance/CareBalance";
import CareBalanceStatus from "./care-balance/CareBalanceStatus";
import CareHistoryTable from "./care-balance/CareHistoryTable";
import CareBalanceStatusModal from "./care-balance/modals/CareBalanceStatusModal";
import { canProductUseCareBalance } from "./care-balance/utils/can-product-use-care-balance";
import { getSubscription } from "../services/careBalanceService";
import { formatProductName } from "../utils/helpers";

class DashboardHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usageData: {
        tipsRead: 0,
        questionsAsked: 0,
        hospitalVisits: 0,
      },
      hasDependants:
        this.props.user.planInfo &&
        this.props.user.planInfo.limits.dependants > 0,
      planExpiryDate: null,
      isLoading: false,
      isTourOpen: false,
      isShowingMore: false,
      showInfoModal: false,
    };
  }

  disableBody = (target) => disableBodyScroll(target);
  enableBody = (target) => enableBodyScroll(target);

  closeTour = () => {
    this.setState({ isTourOpen: false });
    localStorage.setItem("isTourOpen", false);
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  componentDidMount() {
    if (localStorage.getItem("isTourOpen") == null) {
      localStorage.setItem("isTourOpen", true);
      this.setState({ isTourOpen: true });
    } else {
      let isTourOpenSync = localStorage.getItem("isTourOpen");
      this.setState({ isTourOpen: JSON.parse(isTourOpenSync) });
    }

    userService.getUsageData().then((data) => {
      this.setState({
        usageData: data,
      });
    });

    getSubscription().then((plan) => {
      this.setState({
        planExpiryDate: plan.cover_end_date,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.user?.planInfo?.limits?.dependants !==
      this.props.user?.planInfo?.limits?.dependants
    ) {
      this.setState({
        hasDependants: this.props.user?.planInfo?.limits?.dependants > 0,
      });
    }
  }

  addDependants = () => this.setState({ addDependants: true });
  render() {
    const {
      usageData,
      addDependants,
      hasDependants,
      isTourOpen,
      showInfoModal,
      planExpiryDate,
    } = this.state;
    const { user } = this.props;

    const isActive = user?.planInfo?.active_status_id === 1;

    const canUseCareBalance =
      isFeatureEnabled(features.enableCareBalance) &&
      canProductUseCareBalance(user?.planInfo?.product?.id);

    if (_.isEmpty(user)) return <LoadingScreen />;

    if (addDependants) {
      return (
        <Redirect
          push
          to={{
            pathname: `/profile`,
            state: {
              addDependants: true,
            },
          }}
        />
      );
    }

    return (
      <MainContent>
        <PageHeader title={this.props.t("pageTitle")} />

        <PageBody>
          {canUseCareBalance && (
            <CareBalance
              history={this.props.history}
              firstName={user?.firstName}
              lastName={user?.lastName}
              hmoId={user?.hmoId}
              activeStatusId={user?.planInfo?.active_status_id}
            />
          )}

          <ButtonBar
            dataTut="step_two_tour"
            main={
              isFeatureEnabled(features.telemedicine) && {
                name: this.props.t("consultADoctorButtonLabel"),
                func: () => {
                  if (!isActive) {
                    this.setState({ showInfoModal: true });
                    return;
                  }

                  this.props.history.push("/consultations");
                },
              }
            }
            other={
              hasDependants && {
                name: this.props.t("addFamilyButtonLabel"),
                func: this.addDependants,
              }
            }
          />
          {/* Refer and earn suspended */}
          {/* <div className="dashboard-refer-banner">
                        <button
                            className="dashboard-refer-banner__button"
                            onClick={() => this.props.history.push('/refer')}
                        >
                            <i className="fa fa-info-circle"></i> Invite friends, earn money! Tap
                            here
                        </button>
                    </div> */}

          <DashboardProfileCard
            image={user.imageUrl}
            details={getUserProfileDetails(
              user,
              this.props.t,
              this.props.i18n,
              canUseCareBalance,
              planExpiryDate,
            )}
          />

          <div className="dashboard-card contact-us">
            <h2>
              {this.props.t("hospitalContactProblemsMessage1")}{" "}
              <a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>
                {process.env.REACT_APP_CONTACT_EMAIL}
              </a>{" "}
              {this.props.t("or", { ns: "common" })}{" "}
              <a href={`tel:${process.env.REACT_APP_CONTACT_PHONE_NUMBER}`}>
                {process.env.REACT_APP_CONTACT_PHONE_NUMBER}
              </a>{" "}
              {this.props.t("hospitalContactProblemsMessage2")}
            </h2>
          </div>

          <div className="stats-data-wrap">
            <div
              className="stats-data-card"
              data-tut="step_three_tour"
              style={{
                width: "100%",
              }}
            >
              {/* taken out for Egypt */}
              {/* <StatsDataCard
                                name="Tips Read"
                                data={usageData.tipsRead}
                                iconClassName="fa-info-circle"
                            />
                            <StatsDataCard
                                name={this.props.t('dashboard.questions_asked')}
                                data={usageData.questionsAsked}
                                iconClassName="fa-question-circle"
                            /> */}
              <StatsDataCard
                name={this.props.t("hospitalVisits")}
                data={usageData.hospitalVisits}
                iconClassName="fa-hospital"
                style={{
                  width: "100%",
                }}
              />
            </div>
          </div>

          {canUseCareBalance && (
            <CareHistoryTable
              hmoId={user.hmoId}
              limit={3}
              showViewAll
              onViewAll={() => this.props.history.push("/care-history")}
              // hideIfNoTransactions={true}
            />
          )}
        </PageBody>
        <Tour
          onRequestClose={this.closeTour}
          steps={tourDashboard(this.props.t, this.props.i18n)}
          isOpen={isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={12}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
        />

        {showInfoModal && canUseCareBalance && (
          <CareBalanceStatusModal
            onClose={() => this.setState({ showInfoModal: false })}
          />
        )}
      </MainContent>
    );
  }
}

function getUserProfileDetails(
  user,
  t,
  i18n,
  canUseCareBalance,
  planExpiryDate,
) {
  moment.locale(i18n.language);

  const details = {
    groupOne: [
      {
        name: t("enrolleeName"),
        value: `${user.firstName} ${user.lastName}`,
      },
      {
        name: t("enrolleeId"),
        value: user.hmoId,
      },
    ],
    groupTwo: [
      {
        name: t("planInfo"),
        value: user.planInfo
          ? formatProductName(user.planInfo.product.name)
          : `${formatProductName(user.plan)} ${user.planType}`,
      },
      {
        name: t("planExpiryDate"),
        value: planExpiryDate
          ? moment(planExpiryDate)
              .locale(i18n.language)
              .format("ddd, Do MMMM YYYY")
          : t("loading", { ns: "common" }),
      },
    ],
  };

  if (canUseCareBalance) {
    details.groupThree = [
      {
        name: t("careBalanceStatusTitle", { ns: "careBalance" }),
        value: (
          <CareBalanceStatus
            activeStatusId={user?.planInfo?.active_status_id}
          />
        ),
      },
    ];
  }

  return details;
}

const DashboardHomeWithTranslation = withTranslation([
  "dashboardHome",
  "common",
  "tour",
  "careBalance",
])(DashboardHome);
export default withRouter(DashboardHomeWithTranslation);
